export default "__VITE_ASSET__qOFvC4bURbPTAYCRLdBhvw__"